import React from "react"
import { Row, Col, Dropdown } from "react-bootstrap"
import { selectDocument } from "../../redux/actions"
import { useDispatch } from "react-redux"
import Dropzone from "../dropzone"

const RequiredDocuments = ({ uiData }) => {
  const {
    proofDocuments,
    claimUploadListModel,
    pageNumber,
    hideHeaderFooter,
    lockUploadDropdown,
  } = uiData

  const previewsContainer = "BasicDocumentPreview"
  const dispatch = useDispatch()

  function DropdownValueChange(documentId, documentDesc) {
    dispatch(selectDocument(documentId, documentDesc))
  }

  function checkDocumentStatus(documentId) {
    var hasExists = claimUploadListModel.filter(doc => {
      return doc.documentId === documentId
    })

    return hasExists.length > 0
  }

  const countUploadedDocument = () => {
    if (pageNumber === 1) {
      return false
    } else {
      return true
    }

    // return (
    //   claimUploadList.length > 0 ||
    //   tempBenefitInfo.CoverageCode === coverageCode ||
    //   tempBenefitInfo.CoverageDetailId === coverageDetailId ||
    //   coverageDetailId === Constants.basicCoverageDetailId
    // )
  }

  const createLiabilityDocumentsList = () => {
    let liabilityDocumentsArray = []
    proofDocuments.map((item, key) => {
      liabilityDocumentsArray.push(
        <Row
          key={key}
          className="mt-3 paddingLeft15px paddingRight15 unsetMarginTopBottom"
        >
          <Col
            xs={12}
            md={12}
            className={
              "marginTop10px CheckBox documentUpload" +
              (checkDocumentStatus(item.documentId)
                ? " documentSelectedText"
                : "")
            }
          >
            <div>
              {item.description +
                " - " +
                (item.mandatory ? "Required" : "Optional")}
            </div>
          </Col>
        </Row>
      )

      return null
    })
    return liabilityDocumentsArray
  }

  const createLiabilityDocumentsDropdownList = () => {
    let liabilityDocumentsDropdownArray = []
    proofDocuments.map((item, key) => {
      liabilityDocumentsDropdownArray.push(
        <Dropdown.Item
          key={key}
          onClick={DropdownValueChange.bind(
            this,
            item.documentId,
            item.description
          )}
          className={
            "dropdown-item DropdownItem AddTripDocumentClass " +
            (lockUploadDropdown ? "disabled" : "")
          }
        >
          {item.description}
        </Dropdown.Item>
      )

      return null
    })
    return liabilityDocumentsDropdownArray
  }

  return (
    <>
      <div>
        <Row className={pageNumber === 2 ? "" : "hide"}>
          <div
            className={
              "title text-center " +
              (pageNumber === 2 ? "" : "hide") +
              " " +
              (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
            }
          >
            Upload supporting documents
          </div>
          <Row
            className={
              "containerBody " +
              (pageNumber === 5
                ? "blueBG summaryContainerBody mb-4 "
                : "marginTop3x")
            }
          >
            <Col
              xs={{ span: 12, offset: 0 }}
              md={{ span: 12, offset: 0 }}
              className="formContainer"
            >
              <div
                className={
                  "horizontal-align marginBottom1x " +
                  (pageNumber === 2 ? "" : "hide")
                }
              >
                <Col xs={12} md={12}>
                  <div
                    className={"titleText " + (pageNumber === 2 ? "hide" : "")}
                  >
                    Claim documents
                  </div>
                </Col>
              </div>
              <div className="formNoteSection marginBottom19px">
                <span className="highlight-text">PLEASE NOTE:</span> Etiqa’s
                Representatives may contact you and request to present to Etiqa
                the certified copy of the documents.
              </div>
              <Row>
                <p className="DescriptionTxt">
                  Below is a list of minimum documentation required to process
                  your claim. Additional information may be required for further
                  assessment.
                  <br />
                </p>
              </Row>
              {createLiabilityDocumentsList()}
              <br />
              <Row>
                <p className="DescriptionTxt">
                  <span className="note-title">NOTE:&nbsp;</span>
                  <span className="note">
                    Please attach address proof in .jpg, .png, .jpeg, .pdf
                    format only not more than 10MB
                  </span>
                </p>
              </Row>
              <Row className="mt-5 paddingLeft15px paddingRight15">
                <Col xs={12} md={12} className="SupportingDocumentsUploadArea">
                  <div className="mt-2">
                    {countUploadedDocument() && (
                      <>
                        <Row>
                          <p className="DescriptionTxt">Select document name</p>
                          <Dropdown className="dropdown col-10">
                            <Dropdown.Toggle
                              id="dropdown-basic"
                              className="btn btn-secondary dropdown-toggle DropdownHeader"
                            >
                              {uiData.tempSelectedDocument.documentDesc}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="dropdown-menu DropdownMenu">
                              {createLiabilityDocumentsDropdownList()}
                            </Dropdown.Menu>
                          </Dropdown>

                          <Dropzone
                            uiData={uiData}
                            previewsContainer={previewsContainer}
                          />
                        </Row>

                        <Row>
                          <div
                            id={previewsContainer}
                            style={{
                              width: "auto !important",
                              border: "transparent !important",
                              display: "contents",
                            }}
                            className={"dropzone "}
                          ></div>
                        </Row>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Row>
      </div>
    </>
  )
}

export default RequiredDocuments
